<template>
  <div
      v-loading="loadingHead || loadingSalesOrder || loadingBusinessApplication || loadingOperationApplication||loadingProductionApplication||loadingDeliveryNoteApplication"
      style="overflow-y: auto">
    <approval-head-form
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        @sucess-save="submit"
        @loading-status="loadingStatusHead"/>
    <sales-order-preview
        v-if="billType === '1'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusSalesOrder"/>
    <business-application-preview
        v-if="billType === '3'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplication"/>
    <delivery-note-application-preview
        v-if="billType === '6'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusDeliveryNoteApplication"/>
    <business-application-price-apply-preview
        v-if="billType === '20'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplicationPriceApply"/>
    <operation-application-preview
        v-if="billType === '40'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusOperationApplication"/>
    <production-application-preview
        v-if="billType === '13'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusProductionApplication"/>
  </div>
</template>
<script>
  import ApprovalHeadForm from "./ApprovalHeadForm.vue";
  import SalesOrderPreview from "./SalesOrderPreview.vue";
  import BusinessApplicationPreview from "./BusinessApplicationPreview.vue";
  import BusinessApplicationPriceApplyPreview from "./BusinessApplicationPriceApplyPreview";
  import OperationApplicationPreview from "./OperationApplicationPreview.vue";
  import ProductionApplicationPreview from "@/views/workFlow/ProductionApplicationPreview";
  import DeliveryNoteApplicationPreview from "@/views/workFlow/DeliveryNotePreview";

  export default {
    name: "Approval",
    components: {
      BusinessApplicationPriceApplyPreview,
      ApprovalHeadForm,
      SalesOrderPreview,
      BusinessApplicationPreview,
      OperationApplicationPreview,
      ProductionApplicationPreview,
      DeliveryNoteApplicationPreview,
    },
    data() {
      return {
        loadingHead: false,
        loadingSalesOrder: false,
        loadingBusinessApplication: false,
        loadingBusinessApplicationPriceApply: false,
        loadingOperationApplication: false,
        loadingProductionApplication: false,
        loadingDeliveryNoteApplication: false,
        billId: null,
        billType: null,
        sequId: null,
        params: {},
      };
    },
    created() {
      this.billType = this.$route.query.billType + "";
      this.billId = this.$route.query.billId + "";
      this.sequId = this.$route.query.sequId + "";
    },
    mounted() {
    },
    methods: {
      submit(row) {
        this.params = row;
      },
      loadingStatusHead(obj) {
        this.loadingHead = obj.loading;
      },
      loadingStatusSalesOrder(obj) {
        this.loadingSalesOrder = obj.loading;
      },
      loadingStatusBusinessApplication(obj) {
        this.loadingBusinessApplication = obj.loading;
      },
      loadingStatusBusinessApplicationPriceApply(obj) {
        this.loadingBusinessApplicationPriceApply = obj.loading;
      },
      loadingStatusOperationApplication(obj) {
        this.loadingOperationApplication = obj.loading;
      },
      loadingStatusProductionApplication(obj) {
        this.loadingProductionApplication = obj.loading;
      },
      loadingStatusDeliveryNoteApplication(obj) {
        this.loadingDeliveryNoteApplication = obj.loading;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
